import api from 'services/api';

export const FILES_UPLOAD_IMAGE = 'files/uploadImage';

const actions = {
  uploadImage(image) {
    return {
      type: FILES_UPLOAD_IMAGE,
      payload: api.post('/partner/files', {
        data: {
          $base64: image.data.replace(/data:.*?base64,/, ''),
        },
        content_type: image.type,
        filename: image.filename,
        width: image.width,
        height: image.height,
      }),
    };
  },
};

export default actions;
